import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AccountSummaryCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  iconColor = "var(--color-primary)", 
  progress = null,
  actionLabel = null,
  onAction = null,
  variant = "default"
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'warning':
        return 'border-warning/20 bg-warning/5';
      case 'success':
        return 'border-success/20 bg-success/5';
      case 'error':
        return 'border-error/20 bg-error/5';
      default:
        return 'border-border bg-card';
    }
  };

  return (
    <div className={`rounded-lg border p-6 ${getVariantStyles()}`}>
      <div className="flex items-start justify-between">
        <div className="flex items-center space-x-3">
          <div className="p-2 rounded-lg bg-muted">
            <Icon name={icon} size={20} color={iconColor} />
          </div>
          <div>
            <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
            <p className="text-2xl font-semibold text-foreground mt-1">{value}</p>
            {subtitle && (
              <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
            )}
          </div>
        </div>
        {actionLabel && onAction && (
          <Button variant="ghost" size="sm" onClick={onAction}>
            {actionLabel}
          </Button>
        )}
      </div>
      {progress && (
        <div className="mt-4">
          <div className="flex justify-between text-sm text-muted-foreground mb-2">
            <span>Used: {progress?.used}</span>
            <span>Limit: {progress?.limit}</span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className={`h-2 rounded-full transition-all duration-300 ${
                progress?.percentage > 80 ? 'bg-warning' : 
                progress?.percentage > 90 ? 'bg-error' : 'bg-primary'
              }`}
              style={{ width: `${Math.min(progress?.percentage, 100)}%` }}
            />
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            {progress?.percentage?.toFixed(1)}% of limit used
          </p>
        </div>
      )}
    </div>
  );
};

export default AccountSummaryCard;